import api from '@/utils/api';

export const QueryKpiData = data => {
    return api.post(`/performance/getPerformance4Area`, data);
};

export const QueryKpiCustomerData = data => {
    return api.post(``, data);
};

// kpi管理
export const QueryKpiQuota = data => {
    return api.post(`/actionIndicator/getActionIndicatorPage`, data);
};

export const SaveKpiQuota = data => {
    return api.post(`/actionIndicator/addActionIndicator`, data);
};

export const UpdateKpiInfo = data => {
    return api.post(`/actionIndicator/updateActionIndicator`, data);
};

export const BindKpi = data => {
    return api.post(``, data);
};

export const DeleteKpiQuota = ({ indicatorId }) => {
    return api.get(`/actionIndicator/removeActionIndicator/${indicatorId}`);
};

export const QueryKpiInfo = ({ indicatorId }) => {
    return api.get(`/actionIndicator/getActionIndicatorVoById/${indicatorId}`);
};
